import { getGrid, type GridGeometry } from '../../grid';
import type { MapDefinition, MapObjectPlacement, PortalData } from './types';

export class WorldState {
  private map: MapDefinition;
  private grid: GridGeometry;
  private currentMapId: string;

  constructor(map: MapDefinition, mapId: string) {
    this.map = map;
    this.grid = getGrid(map.gridType);
    this.currentMapId = mapId;
  }

  public setMap(map: MapDefinition, mapId: string): void {
    this.map = map;
    this.grid = getGrid(map.gridType);
    this.currentMapId = mapId;
  }

  public getMap(): MapDefinition {
    return this.map;
  }

  public setMapObjects(objects: readonly MapObjectPlacement[]): void {
    this.map = {
      ...this.map,
      objects: [...objects],
    };
  }

  public getGrid(): GridGeometry {
    return this.grid;
  }

  public getCurrentMapId(): string {
    return this.currentMapId;
  }

  public getPortals(): ReadonlyArray<PortalData> {
    return this.map.portals;
  }

  public getPortalAt(x: number, y: number): PortalData | null {
    return this.map.portals.find((p) => p.x === x && p.y === y) ?? null;
  }
}
